export default __webpack_public_path__ + "static/build-generational-wealth-d9a4acd230e120baad154610b1c176e3.jpg";